import { lazy } from 'react';

const Page = lazy(() => import('./page'));

export const CreateReshuffleRequest = () => <Page />;
